export const state = () => ({
    job_post: null,
    detailing_job: null,
    categorize_job: null,
    describe_job: null,
    requirements: null,
    wage_structure: null,

    current_step: 1,

    question_type: null,
    show_add_question_modal: false,
});

export const mutations = {
    setJobPost(state: any, payload: any) {
        state.job_post = payload;
    },

    setDetailingJob(state: any, payload: any) {
        state.detailing_job = payload;
    },

    setCategorizeJob(state: any, payload: any) {
        state.categorize_job = payload;
    },

    setDescribeJob(state: any, payload: any) {
        state.describe_job = payload;
    },

    setRequirements(state: any, payload: any) {
        state.requirements = payload;
    },

    setWageStructure(state: any, payload: any) {
        state.wage_structure = payload;
    },

    setCurrentStep(state: any, payload: any) {
        state.current_step = payload;
    },

    setQuestionType(state: any, payload: any) {
        state.question_type = payload;
    },

    setShowAddQuestionTypeModal(state: any, payload: any) {
        state.show_add_question_modal = payload;
    },
};

export const getters = {
    getJobPost: (state: any) => state.job_post,
    getDetailingJob: (state: any) => state.detailing_job,
    getCategorizeJob: (state: any) => state.categorize_job,
    getDescribeJob: (state: any) => state.describe_job,
    getRequirements: (state: any) => state.requirements,
    getWageStructure: (state: any) => state.wage_structure,
    getCurrentStep: (state: any) => state.current_step,
    getShowAddQuestionTypeModal: (state: any) => state.show_add_question_modal,
    getQuestionType: (state: any) => state.question_type,
};

export const actions = {
    createJobPost(state: any) {
        let job = {
            ...state.state.detailing_job,
        };

        if (['In Person', 'Hybrid'].includes(job.location_type)) {
            job = {
                ...job,
                ...state.state.detailing_job.location_information,
            };
        }

        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/company/' + state.rootState.auth.user.company.uuid + '/jobs', job)
                .then((res) => {
                    if (res.status === 201) {
                        this.$gtm.push({
                            event: 'draftJob',
                            job_id: res.data.uuid,
                            job_title: res.data.title,
                            user_id: state.rootState.auth.user.uuid,
                            company_id: state.rootState.auth.user.company.uuid,
                        });
                        state.commit('setJobPost', res.data);
                    }
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateJobPost(state: any, payload: any) {
        let details = JSON.parse(JSON.stringify(state.state.detailing_job));

        if (['In Person', 'Hybrid'].includes(state.state.detailing_job.location_type)) {
            details = {
                ...details,
                ...state.state.detailing_job.location_information,
            };
        }

        let emptyLocation =   {
            line1: null,
            line2: null,
            city: null,
            province: null,
            postal_code: null,
            lat: null,
            long: null
        }

        if (state.state.describe_job) {
            details.description = state.state.describe_job.description;
            details.additional_notes = state.state.describe_job.additional_notes;
            details.enquiry_info = state.state.describe_job.enquiry_info;
        }

        Object.keys(details).forEach((key) => !details[key] && delete details[key]);

        //when location is removed pass null values to delete job location
        if (!state.state.detailing_job.location_information){
            details = {
                ...details,
                ...emptyLocation
            }
        }

        return new Promise((resolve, reject) => {
            this.$axios
                .put('/api/jobs/' + state.state.job_post.uuid + '/update', details)
                .then((res) => {
                    state.commit('setJobPost', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    getJobPost(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/jobs/single/' + payload)
                .then((res) => {
                    let details = {
                        title: res.data.title,
                        job_type: res.data.job_type,
                        start_date: res.data.start_date ? res.data.start_date : '',
                        end_date: res.data.end_date ? res.data.end_date : '',
                        location_type: res.data.location_type,
                        location_information: res.data.location_information,
                        application_url: res.data.application_url,
                    };

                    const describe_job = {
                        description: res.data.description,
                        additional_notes: res.data.additional_notes,
                        enquiry_info: res.data.enquiry_info,
                    };

                    state.commit('setJobPost', res.data);
                    state.commit('setDetailingJob', details);
                    state.commit('setDescribeJob', describe_job);
                    state.commit('setCategorizeJob', res.data.industries);
                    state.commit('setRequirements', res.data.requirements);
                    state.commit('setWageStructure', res.data.wageStructure);
                    state.commit('jobs/question/setAdvancedQuestions', res.data.questions, { root: true });
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteJobPost(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete('/api/jobs/' + payload)
                .then((res) => {
                    this.$gtm.push({
                        event: 'deletedJob',
                        job_id: state.rootState.jobs.single.job_post.uuid,
                        job_title: state.rootState.jobs.single.job_post.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    publishJobPost(state: any, payload: any) {
        const { job_uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_uuid}/publish`, data)
                .then((res) => {
                    this.$gtm.push({
                        event: 'publishedJob',
                        job_id: res.data.uuid,
                        job_title: res.data.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });

                    let jobs = JSON.parse(JSON.stringify(state.rootState.jobs.filtered_company_jobs));

                    jobs?.data.find((job) => {
                        if (job.uuid === job_uuid) {
                            job.status = res.data.status;
                            job.expires = res.data.expires;
                            job.published_at = res.data.published_at;
                        }
                    });

                    state.dispatch('jobs/setFilteredCompanyJobs', jobs, {
                        root: true,
                    });

                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    unPublishJobPost(state: any, payload: any) {
        let jobs = JSON.parse(JSON.stringify(state.rootState.jobs.filtered_company_jobs));

        jobs.data.find((object) => {
            if (object.uuid === payload) {
                object.status = 'Unpublished';
            }
        });

        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/' + payload + '/un-publish')
                .then((res) => {
                    this.$gtm.push({
                        event: 'unpublishedJob',
                        job_id: res.data.uuid,
                        job_title: res.data.title,
                        user_id: state.rootState.auth.user.uuid,
                        company_id: state.rootState.auth.user.company.uuid,
                    });

                    state.dispatch('jobs/setFilteredCompanyJobs', jobs, {
                        root: true,
                    });

                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    createJobIndustry(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/' + state.state.job_post.uuid + '/industries', payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateJobIndustry(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .put('/api/jobs/industries/' + payload.uuid, payload.data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteJobIndustry(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete('/api/jobs/industries/' + payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateIndustryFieldsOfInterest(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/industries/' + payload.uuid + '/fields-of-interest', payload.data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    addRequirement(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/' + state.state.job_post.uuid + '/requirement', payload)
                .then((res) => {
                    state.commit('setRequirements', res.data.requirements);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateRequirement(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .put('/api/jobs/' + state.state.job_post.uuid + '/requirement/' + payload.id, payload)
                .then((res) => {
                    state.commit('setRequirements', res.data.requirements);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteRequirement(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete('/api/jobs/' + state.state.job_post.uuid + '/requirement/' + payload)
                .then((res) => {
                    state.commit('setRequirements', res.data.requirements);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    createJobQuestion(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/' + state.state.job_post.uuid + '/questions', payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    updateJobQuestion(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .put('/api/jobs/questions/' + payload.uuid, payload.data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteJobQuestion(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete('/api/jobs/questions/' + payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    addWageStructure(state: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post('/api/jobs/' + state.state.job_post.uuid + '/wage-structure', payload)
                .then((res) => {
                    state.commit('setWageStructure', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    deleteWageStructure(state: any, wage_structure_uuid: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete(`api/jobs/${state.state.job_post.uuid}/wage-structure/${wage_structure_uuid}`)
                .then((res) => {
                    state.commit('setWageStructure', null);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    setJobPost(state: any, payload: any) {
        state.commit('setJobPost', payload);
    },

    setWageStructure(state: any, payload: any) {
        state.commit('setWageStructure', payload);
    },

    updateDetailingJob(state: any, payload: any) {
        state.commit('setDetailingJob', payload);
    },

    updateCategorizeJob(state: any, payload: any) {
        state.commit('setCategorizeJob', payload);
    },

    updateDescribeJob(state: any, payload: any) {
        state.commit('setDescribeJob', payload);
    },

    updateRequirements(state: any, payload: any) {
        state.commit('setRequirements', payload);
    },

    setCurrentStep(state: any, payload: any) {
        state.commit('setCurrentStep', payload);
    },

    updateShowAddQuestionTypeModal(state: any, payload: any) {
        state.commit('setShowAddQuestionTypeModal', payload);
    },

    updateQuestionType(state: any, payload: any) {
        state.commit('setQuestionType', payload);
    },
};
